import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import classNames from 'classnames';
import {
  isEmptyOrNil,
  createUrlSlug
} from 'core/helpers';
import { Carousel } from 'components/carousel/carousel';
import { producerIconsBig } from 'components/games-filters/producer-icons';

export const FooterProvidersSlider = ({ producers }) => {
  const [autoplaySpeed, setAutoplaySpeed] = useState(2000);

  const carouselSettings = {
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed,
    speed: 2000,
    easing: 'linear',
    lazyLoad: false,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    variableWidth: true
  };

  useEffect(() => {
    if (producers.length > 0) {
      setAutoplaySpeed(0);
    }
  }, [producers]);

  return (
    <Carousel
      settings={carouselSettings}
    >
      {!isEmptyOrNil(producers) && R.pluck('slug', producers).map(
        (producer) => {
          const Icon = producerIconsBig[createUrlSlug(producer)];

          if (Icon) {
            return (
              <div
                key={producer}
                className={classNames('footer-producer-icons-container text-center mx-1 mx-md-2 my-1_5 w-100', producer === '1x2-gaming' ? 'gaming-1x2' : producer)}
              >
                <Icon className="p-0_25 p-md-0 footer-producer" />
              </div>
            );
          }

          return null;
        }
      )}
    </Carousel>
  );
};

FooterProvidersSlider.propTypes = {
  producers: PropTypes.arrayOf(PropTypes.shape()),
};

FooterProvidersSlider.defaultProps = {
  producers: [],
};
